// extracted by mini-css-extract-plugin
export default {"constructorStub":"umDuc","iconWrapper":"_E1JL","icon":"FSJeb","iconImg":"Ssuvh","linkWrapper":"xts9M","discount":"IFvZI"};